<section class="search-mobile" *ngIf="toggle" @openAnimation>
   <form class="search-mobile__search-bar" (submit)="submitSearch($event)">
      <app-search-input (changeSearch)="searchField($event.target.value)"></app-search-input>
   </form>
</section>
